import React from 'react';
import {createSelector} from 'reselect';
import {connect} from 'react-redux';
import {bindDispatch} from 'app/utils/redux';

import ATSOnboardView from 'views/ATS-onboard';

const ATSOnboardContainer = (props) => {
  let {entity, ats, actions} = props;
  return (
    <div className='mx4 my3 container'>
      <ATSOnboardView
        entity={entity}
        ats={ats}
        updateAtsName={actions.updateAtsName}
        updateAtsEmail={actions.updateAtsEmail}
        updateAtsNotificationUrl={actions.updateAtsNotificationUrl}
        updateAtsAssessmentPurchased={actions.updateAtsAssessmentPurchased}
        handleCreateAts={actions.handleCreateAts}
      />
    </div>
  );
}

const selector = createSelector(
  state => state.entity,
  state => state.ats,
  (entity, ats) => ({ entity, ats })
);

export default connect(selector, bindDispatch)(ATSOnboardContainer);



// WEBPACK FOOTER //
// ./src/containers/ATS/ATSOnboardContainer.js